import React, { useState, useEffect, useRef } from 'react';
import './WhyIbots.css';

// ─────────────────────────────────────────────
// 🖼️  IMAGE SETUP
// Put your 2 background images + center photo in:
//   public/images/why-bg1.jpg
//   public/images/why-bg2.jpg
//   public/images/why-center.png
// ─────────────────────────────────────────────
import bg1 from '../../assets/why-bg1.png';
import bg2 from '../../assets/why-bg2.png';
import centerImg from '../../assets/why-center.png';
const BG_IMAGES = [bg1, bg2];
const CENTER_IMG = centerImg;

// ── SVG Icons ────────────────────────────────

const HandsOnSVG = () => (
  <svg viewBox="0 0 60 60" fill="none">
    {/* palm / hand */}
    <path d="M13 52 L13 31 Q13 27 17 27 Q21 27 21 31 L21 25 Q21 21 25 21 Q29 21 29 25 L29 24 Q29 20 33 20 Q37 20 37 24 L37 26 Q37 22 41 22 Q45 22 45 26 L45 46 Q45 51 40 53 L21 53 Q13 53 13 48 Z"
      stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.12)" strokeLinejoin="round"/>
    {/* circuit on palm */}
    <circle cx="29" cy="37" r="5" stroke="white" strokeWidth="1.8" fill="none"/>
    <path d="M24 37 L19 37 M34 37 L39 37 M29 32 L29 28 M29 42 L29 47"
      stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="19" cy="37" r="1.5" fill="white"/>
    <circle cx="39" cy="37" r="1.5" fill="white"/>
    <circle cx="29" cy="28" r="1.5" fill="white"/>
  </svg>
);

const TrainersSVG = () => (
  <svg viewBox="0 0 60 60" fill="none">
    {/* whiteboard */}
    <rect x="4" y="8" width="34" height="22" rx="2" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.1)"/>
    <path d="M8 16 L22 16 M8 21 L28 21 M8 26 L18 26" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
    {/* board stand */}
    <path d="M21 30 L21 34" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    {/* trainer head */}
    <circle cx="21" cy="4" r="3.5" stroke="white" strokeWidth="1.5" fill="none"/>
    {/* two audience people */}
    <circle cx="46" cy="26" r="4" stroke="white" strokeWidth="1.5" fill="none"/>
    <path d="M40 44 Q41 36 46 36 Q51 36 52 44" stroke="white" strokeWidth="1.8" fill="none" strokeLinecap="round"/>
    <circle cx="54" cy="32" r="3.5" stroke="white" strokeWidth="1.5" fill="none"/>
    <path d="M50 48 Q51 42 54 42 Q57 42 58 48" stroke="white" strokeWidth="1.8" fill="none" strokeLinecap="round"/>
  </svg>
);

const InnovationSVG = () => (
  <svg viewBox="0 0 60 60" fill="none">
    {/* robot head */}
    <rect x="15" y="5" width="30" height="24" rx="4" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.1)"/>
    <circle cx="24" cy="15" r="3.5" stroke="white" strokeWidth="1.5" fill="none"/>
    <circle cx="36" cy="15" r="3.5" stroke="white" strokeWidth="1.5" fill="none"/>
    <path d="M24 22 Q30 26 36 22" stroke="white" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
    {/* antenna */}
    <path d="M30 5 L30 1" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="30" cy="1" r="2" fill="white" opacity="0.9"/>
    {/* body */}
    <rect x="19" y="31" width="22" height="20" rx="3" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.1)"/>
    {/* arms */}
    <path d="M11 36 L19 36 M41 36 L49 36" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    {/* wheels */}
    <circle cx="23" cy="55" r="3" stroke="white" strokeWidth="1.5" fill="none"/>
    <circle cx="37" cy="55" r="3" stroke="white" strokeWidth="1.5" fill="none"/>
    {/* chest detail */}
    <rect x="24" y="36" width="12" height="8" rx="2" stroke="white" strokeWidth="1.2" fill="none" opacity="0.6"/>
  </svg>
);

const InteractiveSVG = () => (
  <svg viewBox="0 0 60 60" fill="none">
    {/* monitor */}
    <rect x="4" y="6" width="38" height="28" rx="3" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.1)"/>
    {/* monitor stand */}
    <path d="M20 34 L18 44 M26 34 L28 44 M14 44 L32 44" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    {/* screen lines */}
    <path d="M10 16 L17 16 M10 20 L22 20 M10 24 L15 24" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
    {/* person on screen */}
    <circle cx="33" cy="15" r="5" stroke="white" strokeWidth="1.5" fill="none"/>
    <path d="M27 30 Q27 24 33 24 Q39 24 39 30" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    {/* pointer / cursor */}
    <path d="M47 34 L53 27 L52 40 L49.5 37.5 L48 44 L44.5 42 L46 35.5 Z"
      stroke="white" strokeWidth="1.5" fill="rgba(255,255,255,0.15)" strokeLinejoin="round"/>
  </svg>
);

const Support247SVG = () => (
  <svg viewBox="0 0 60 60" fill="none">
    {/* outer ring */}
    <circle cx="30" cy="30" r="24" stroke="white" strokeWidth="2.5" fill="rgba(255,255,255,0.1)"/>
    {/* inner dashed ring */}
    <circle cx="30" cy="30" r="17" stroke="white" strokeWidth="1" strokeDasharray="3 3" fill="none" opacity="0.4"/>
    {/* 24/7 text */}
    <text x="30" y="26" textAnchor="middle" fill="white" fontSize="11" fontWeight="900"
      fontFamily="Segoe UI, sans-serif">24</text>
    <text x="30" y="39" textAnchor="middle" fill="white" fontSize="11" fontWeight="900"
      fontFamily="Segoe UI, sans-serif">/7</text>
    {/* tick marks */}
    <path d="M30 6 L30 3 M30 54 L30 57 M54 30 L57 30 M3 30 L6 30
             M46.2 13.8 L48.3 11.7 M11.7 48.3 L13.8 46.2
             M46.2 46.2 L48.3 48.3 M11.7 11.7 L13.8 13.8"
      stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.45"/>
  </svg>
);

const FutureSkillsSVG = () => (
  <svg viewBox="0 0 60 60" fill="none">
    {/* bulb body */}
    <path d="M30 5 C20 5 13 12 13 22 C13 30 18 35 25 38 L25 46 L35 46 L35 38 C42 35 47 30 47 22 C47 12 40 5 30 5 Z"
      stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.1)"/>
    {/* base rings */}
    <path d="M25 46 L25 48 Q25 52 30 52 Q35 52 35 48 L35 46" stroke="white" strokeWidth="1.5" fill="none"/>
    <path d="M26 50 L34 50" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    {/* bar chart inside */}
    <path d="M22 34 L22 28 M26.5 34 L26.5 24 M31 34 L31 20 M35.5 34 L35.5 26"
      stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    {/* glow rays */}
    <path d="M30 3 L30 1 M17 9 L15 7 M43 9 L45 7 M12 22 L10 22 M48 22 L50 22"
      stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
  </svg>
);

// ── Feature Data ─────────────────────────────

const LEFT_FEATURES = [
  {
    id: 'handson', Icon: HandsOnSVG,
    title: 'Hands-on learning',
    desc: 'Students work directly with sensors, microcontrollers, and real hardware equipment.',
  },
  {
    id: 'trainers', Icon: TrainersSVG,
    title: 'Experienced Trainers',
    desc: 'Programs are conducted by engineers and technical professionals.',
  },
  {
    id: 'innovation', Icon: InnovationSVG,
    title: 'Innovation & Creativity',
    desc: 'Students are encouraged to design solutions and develop prototypes.',
  },
];

const RIGHT_FEATURES = [
  {
    id: 'interactive', Icon: InteractiveSVG,
    title: 'Interactive training',
    desc: 'Students actively participate in building projects and experimenting with technology.',
  },
  {
    id: 'support', Icon: Support247SVG,
    title: 'Technical Support',
    desc: 'Trainers provide ongoing guidance and support throughout the training program.',
  },
  {
    id: 'future', Icon: FutureSkillsSVG,
    title: 'Future-Ready Skills',
    desc: 'Helps students develop technical knowledge, engineering skills, and problem-solving abilities.',
  },
];

// ── Component ────────────────────────────────

function WhyIbots() {
  const [bgIdx, setBgIdx]     = useState(0);
  const [visible, setVisible] = useState(false);
  const [activeId, setActive] = useState(null);
  const [animId, setAnimId]   = useState(null);
  const ref = useRef(null);

  // Background image cycling
  useEffect(() => {
    const t = setInterval(() => setBgIdx(i => (i + 1) % BG_IMAGES.length), 5000);
    return () => clearInterval(t);
  }, []);

  // Trigger slide-in when section scrolls into view
  useEffect(() => {
  const obs = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        setVisible(true);
      } else {
        setVisible(false); // ← resets when scrolled away
      }
    },
    { threshold: 0.15 }
  );
  if (ref.current) obs.observe(ref.current);
  return () => obs.disconnect();
}, []);

  const handleClick = (id) => {
    setActive(prev => (prev === id ? null : id));
    setAnimId(id);
    setTimeout(() => setAnimId(null), 700);
  };

  const renderFeature = (f, side, i) => {
    const isActive = activeId === f.id;
    const isAnim   = animId   === f.id;
    return (
      <div
        key={f.id}
        className={`wi__feat wi__feat--${side} ${visible ? 'wi__feat--in' : ''} ${isActive ? 'wi__feat--active' : ''}`}
        style={{ transitionDelay: `${i * 0.45}s` }}
        onClick={() => handleClick(f.id)}
      >
        {side === 'left' ? (
          <>
            <div className="wi__feat-text wi__feat-text--left">
              <h3 className="wi__feat-title">{f.title}</h3>
              <p className="wi__feat-desc">{f.desc}</p>
            </div>
            <div className={`wi__icon ${isAnim ? 'wi__icon--bounce' : ''}`}>
              <f.Icon />
            </div>
          </>
        ) : (
          <>
            <div className={`wi__icon ${isAnim ? 'wi__icon--bounce' : ''}`}>
              <f.Icon />
            </div>
            <div className="wi__feat-text wi__feat-text--right">
              <h3 className="wi__feat-title">{f.title}</h3>
              <p className="wi__feat-desc">{f.desc}</p>
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <section className="wi__section" ref={ref}>

      {/* Cycling background images */}
      {BG_IMAGES.map((img, i) => (
        <div
          key={i}
          className="wi__bg"
          style={{ backgroundImage: `url(${img})`, opacity: i === bgIdx ? 1 : 0 }}
        />
      ))}
      <div className="wi__overlay" />

      {/* Content */}
      <div className="wi__content">
        <h2 className="wi__heading">Why Schools & Colleges Choose ibots?</h2>
        <p className="wi__subheading">
          Choosing ibots gives students the opportunity to learn technology in a practical,<br />
          engaging, and innovation-driven environment.
        </p>

        <div className="wi__grid">

          {/* Left column */}
          <div className="wi__col">
            {LEFT_FEATURES.map((f, i) => renderFeature(f, 'left', i))}
          </div>

          {/* Center image */}
          <div className={`wi__center ${visible ? 'wi__center--in' : ''}`}>
            <img src={CENTER_IMG} alt="ibots training" className="wi__center-img" />
          </div>

          {/* Right column */}
          <div className="wi__col">
            {RIGHT_FEATURES.map((f, i) => renderFeature(f, 'right', i))}
          </div>

        </div>
      </div>
    </section>
  );
}

export default WhyIbots;